import React, { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

/**
 * Component that displays session timeout notifications
 * Should be placed at the app level to show notifications globally
 */
export const SessionTimeoutNotification: React.FC = () => {
  const { sessionTimeoutReason } = useAuth();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (sessionTimeoutReason) {
      let notificationMessage = '';

      switch (sessionTimeoutReason) {
        case 'token_expired':
          notificationMessage = 'Your session has expired. Please log in again.';
          break;
        case 'session_expired':
          notificationMessage = 'Your session has timed out. Please log in again.';
          break;
        case 'unauthorized':
          notificationMessage = 'Authentication required. Please log in.';
          break;
        default:
          notificationMessage = 'Your session has ended. Please log in again.';
      }

      setMessage(notificationMessage);
      setOpen(true);
    }
  }, [sessionTimeoutReason]);

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  if (!sessionTimeoutReason) {
    return null;
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity="warning" sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SessionTimeoutNotification;
